import {HttpClient} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {Router} from '@angular/router';
import {of} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DemoService {
  private readonly http = inject(HttpClient);
  private readonly router = inject(Router);


  public resetData() {
    return this.http
      .put(environment.baseUrl + '/testing/resetEnv', {})
      .pipe(
        tap(() => {
          this.router.navigate(['/workflow']).then(() => {
            window.location.reload();
          });
        }),
        catchError(() => {
          console.error('Reset data failed');
          return of();
        })
      );
  }

  public addNewContainer(): void {
    this.http
      .post(environment.baseUrl + '/testing/addNewContainer', {})
      .pipe(
        tap(() => {
          this.router.navigate(['/workflow']).then(() => {
            window.location.reload();
          });
        }),
        catchError(() => {
          console.error('Add New Tyres Container failed');
          return of();
        })
      )
      .subscribe(() => {
      });
  }

  public addNewPreparation(): void {
    this.http
      .post(environment.baseUrl + '/testing/addNewPreparation', {})
      .pipe(
        tap(() => {
          this.router.navigate(['/workflow']).then(() => {
            window.location.reload();
          });
        }),
        catchError(() => {
          console.error('Add new preparation failed');
          return of();
        })
      )
      .subscribe(() => {
      });
  }
}
